import React, { useEffect } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  ParagraphText,
  Card,
  HeadingText,
  StackLayout,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { COB_LIBRARY_ASSET_KEYS } from '../../../types/cob-library.types';
import COBQuestioner from '../../../assets/json/COB_QUESTIONER.json';

export function CobLanding(props: any) {
  // eslint-disable-next-line react/prop-types
  const { errorHandling, nextDisabled } = props;
  const isBelow400 = useMediaQuery(queryHelpers.down(400));
  const isHeight786 = useMediaQuery('(max-height:786px)');
  const isUp400 = useMediaQuery(queryHelpers.up(400));
  localStorage.removeItem('pcnValidationSuccess');
  localStorage.setItem('pcnValidationSuccess', '');
  localStorage.removeItem('memberCopyOf');
  useEffect(() => {
    errorHandling(true);
    nextDisabled(false);
  }, [errorHandling, nextDisabled]);

  return (
    <StackLayout
      horizontalAlignment="center"
      css={
        {
          backgroundColor: 'White',
          maxWidth: '570px',
          minHeight: '663px',
          borderRadius: '9px',
          height: '100%',
          '@mobile': { height: isHeight786 ? 'auto' : '663px' },
          '@desktop': { width: '480px' },
        } as GDSStyleObject
      }
      data-testid="cobLanding"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$none $none',
            marginTop: '-8px',
          } as GDSStyleObject
        }
      >
        <Card.Flat
          css={{
            maxWidth: '480px',
            height: 'auto',
            minHeight: '550px',
            border: '0px solid',
            '@mobile': {
              paddingLeft: isBelow400 ? '0px' : '10px',
              paddingRight: isBelow400 ? '0px' : '10px',
              width: isUp400 ? '105vw' : '100vw',
              maxHeight: '100vh',
            },
            '@desktop': { width: '480px' },
            '@laptop': { width: '480px' },
            '@mobileLandscape': { width: '480px' },
            '@tablet': { width: '480px' },
          }}
        >
          <Card.Image
            image={
              useStaticAsset(
                COB_LIBRARY_ASSET_KEYS.TOP_IMAGE_COB_ICON,
              ) as string
            }
            imageAlt="Other Insurance Information/COB"
          />
          <Card.Section
            css={{
              '@mobile': {
                padding: isBelow400 ? '20px 10px 10px 10px' : '$oneAndHalf',
              },
            }}
          >
            <HeadingText
              size="md"
              level="4"
              css={
                {
                  fontSize: '$headingOne',
                  padding: '$none $none $one $none',
                  marginLeft: '0px',
                  lineHeight: '33px',
                } as GDSStyleObject
              }
            >
              {COBQuestioner.COB.COVERSECTION.TITLE}
            </HeadingText>
            <ParagraphText
              css={{
                marginTop: '$half',
                marginBottom: '$oneAndHalf',
                fontSize: '$bodyOne',
                lineHeight: '$headingFour',
                '@desktop': { width: '442px' },
                '@mobile': { width: isBelow400 ? '339px' : '380px' },
              }}
            >
              {COBQuestioner.COB.COVERSECTION.CONTENT}
            </ParagraphText>
          </Card.Section>
        </Card.Flat>
      </Box>
    </StackLayout>
  );
}
